<p>copy-msg works!</p>
